<template>
    <div>
        <el-breadcrumb class="Breadcrumb" separator="/">
            <el-breadcrumb-item>轮播图管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider></el-divider>
        <el-tabs v-model="key" type="card" @tab-click="handleClick">
            <template v-for="item in titleData">
                <el-tab-pane :label="item.name" :name="item.key"></el-tab-pane>
            </template>
            <el-row :gutter="24">
                <el-col :span="4" :offset="20">
                    <el-button type="primary" @click="openAdd()" icon="el-icon-plus">添加</el-button>
                </el-col>
            </el-row>
            <div class="table">
                <el-table :data="tableData" stripe style="width: 100%">
                    <el-table-column prop="seq" label="排序">
                    </el-table-column>
                    <el-table-column prop="imgPath" label="图片">
                        <template slot-scope="scope">
                            <el-image style="width: 150px; height: 150px" :src="scope.row.imgPath" fit="contain"></el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ddicName" label="轮播图类型">
                    </el-table-column>
                    <el-table-column label="启用/禁用">
                        <template slot-scope="scope">
                            <el-switch v-model="scope.row.isUsed" active-color="#13ce66" inactive-color="#ff4949"
                                :disabled="scope.row.canEdit == false" @change="changeDemo(scope.row.id, scope.row.isUsed)">
                            </el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column prop="updateDate" label="最后操作时间">
                    </el-table-column>
                    <el-table-column prop="id" fixed="right" label="操作" width="250">
                        <template slot-scope="scope">
                            <el-button @click="topFun(scope.row.id)" type="text" icon="el-icon-upload2"
                                size="small">置顶</el-button>
                            <el-button @click="upFun(scope.row.id)" type="text" icon="el-icon-caret-top"
                                size="small">上移</el-button>
                            <el-button @click="downFun(scope.row.id)" type="text" icon="el-icon-caret-bottom"
                                size="small">下移</el-button>
                            <el-button @click="bottomFun(scope.row.id)" type="text" icon="el-icon-download"
                                size="small">置底</el-button>
                            <el-button @click="deleteFun(scope.row.id)" type="text" icon="el-icon-delete"
                                size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--分页-->
            <div class="pagination">
                <el-pagination background @size-change="changSizeFun" @current-change="changpageFun"
                    :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum">
                </el-pagination>
            </div>
        </el-tabs>

        <!-- 添加弹窗-->
        <el-dialog :title="name" :visible.sync="addPop" class="customClass" width="30%">
            <el-form :model="formDate" width="500px">
                <el-upload class="upload-demo" drag :show-file-list="false" :action="uploadUrl" :headers="upheader"
                    :on-success="handleSuccess"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove" >
                    <template v-if="!formDate.image">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </template>
                    <img v-else style="width: 200px; height: 200px;" :src="formDate.image" fit="contain">
                    <!-- <el-image v-else style="width: 100%;" :src="formDate.image" fit="contain"></el-image> -->
                </el-upload>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addPop = false">取 消</el-button>
                <el-button type="primary" @click="addSlideFun()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    mounted() {
        this.getTitle();
    },
    methods: {
        handlePictureCardPreview(file){
            console.log(file)
        },
        handleRemove(file, fileList){
            console.log(file, fileList)
        },
        //查询列表
        getTitle() {
            let data = {}
            this.$get(api + "/newsSlide/getSelectList", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.titleData = res.data;
                    this.key = this.titleData[0].key;
                    this.name = '添加' + this.titleData[0].name;
                    this.getList();
                }else{
                  this.$message('轮播图获取错误')
                }
            }).catch( err =>{
                console.log('err',err)
              this.$message(err)
            })
        },
        handleClick(tab, event) {
          this.key = tab.name;
            this.name = tab.label;
            this.pageSize = 10,
            this.pageNum = 1,
            this.totalNum = 0,
            this.getList();
        },
        handleSuccess(response, file, fileList) {
            // 这里可以根据你的需要自定义成功后的操作
            // console.log('文件上传成功');
            // console.log('服务器返回的响应：', response);
            // console.log('已上传的文件：', file);
            // console.log('所有已上传的文件：', fileList);
            this.formDate.image = response.data.fullUrl;
            this.formDate.filePath = response.data.url;
        },

        getList() {
            let data = {
                ddic: this.key,
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }
            this.$get(api + "/newsSlide/getList", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.tableData = res.data;
                    this.totalNum = res.totalNum
                }
            })
        },
        //打开添加页面
        openAdd() {
            this.formDate.image = '';
            this.formDate.filePath = '';
            this.addPop = true;
            this.uploadUrl = api + '/main/' + this.key + '/upload'
            this.upheader = { "token": this.$store.state.userInfo.token }

        },
        //添加轮播图
        addSlideFun() {
            let data = {
                imgPath: this.formDate.filePath,
                ddic: this.key,
            }
            this.$post(api + "/newsSlide/addSlideShow", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.formDate.image = '';
                    this.formDate.filePath = '';
                    this.addPop = false;
                    this.$message({
                        type: 'success',
                        message: '添加成功!'
                    })
                    this.getListFun(1);
                } else {
                    this.$message.error(res.desc);
                }
            })
        },
        //开启/关闭用户
        changeDemo(id, isUsed) {
            //true = 开启 false = 关闭
            let data = {}
            let uri = isUsed ? "enable" : "disable"
            let url = "/newsSlide/" + uri + "/" + id;
            this.$post(api + url, data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.getListFun(this.pageNum);
                } else {
                    this.$message.error(res.desc);
                }
            })
        },
        topFun(id) {
            let url = "/newsSlide/top/" + id;
            this.changePlace(url);
        },
        upFun(id) {
            let url = "/newsSlide/up/" + id;
            this.changePlace(url);
        },
        downFun(id) {
            let url = "/newsSlide/down/" + id;
            this.changePlace(url);
        },
        bottomFun(id) {
            let url = "/newsSlide/bottom/" + id;
            this.changePlace(url);
        },
        //换位置
        changePlace(url) {
            let data = {}
            this.$post(api + url, {}).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.getListFun(this.pageNum);
                } else {
                    this.$message.error(res.desc);
                }
            })
        },
        deleteFun(id) {
            let data = {}
            this.$post(api + "/newsSlide/delete/" + id, data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.getListFun(1);
                } else {
                    this.$message.error(res.desc);
                }
            })
        },
        //特定pageNum查询列表
        getListFun(val) {
            this.pageNum = val;
            this.getList();
        },

        //更换pageSize
        changSizeFun(val) {
          console.log(`每页 ${val} 条`);
          this.pageSize = val;
          this.getList();
        },
        //翻页
        changpageFun(val) {
          console.log(this.pageNum);
          this.pageNum = val;
          this.getList();
        },

    },
    data() {
        return {
            key: '',
            name: '',
            pageSize: 10,
            pageNum: 1,
            totalNum: 0,
            titleData: [],
            tableData: [],
            //
            addPop: false,
            uploadUrl: '',
            upheader: {},
            formDate: {
                image: '',
                filePath: '',
            }
        }
    }
}
</script>


<style scoped>

.upload-demo{
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.Breadcrumb {
    margin-bottom: 15px;
}

.search {
    padding-bottom: 10px;
    border-bottom: 1px solid #606266;
    margin-bottom: 15px;
}

.el-row {
    margin-bottom: 20px;
}

.el-col {
    border-radius: 4px;
}

.bg-purple-dark {
    background: #99a9bf;
}

.bg-purple {
    background: #d3dce6;
}

.bg-purple-light {
    background: #e5e9f2;
}

.grid-content {
    border-radius: 4px;
    min-height: 36px;
}

.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}
</style>



// WEBPACK FOOTER //
// src/pages/news/imgs/Newimg.vue